import { X } from 'lucide-react';

export function Toast({
  message,
  tone,
  onClose
}: {
  message: string | null;
  tone: 'neutral' | 'error';
  onClose: () => void;
}): JSX.Element | null {
  if (!message) return null;

  return (
    <div className="fixed bottom-4 left-1/2 z-50 flex w-[min(92vw,520px)] -translate-x-1/2 items-center justify-between gap-3 rounded-lg border border-[color:var(--line)] bg-[color:var(--panel)] px-4 py-3 text-sm shadow-frame">
      <span className={tone === 'error' ? 'text-[color:var(--danger)]' : 'text-[color:var(--text)]'}>{message}</span>
      <button className="icon-button h-8 min-w-8 px-2" onClick={onClose} aria-label="Dismiss message">
        <X size={16} />
      </button>
    </div>
  );
}
